import Text from 'components/3catinfo/Text';
import Tag from '../Tag';
import styles from './temesrelacionats.module.scss';

const TemesRelacionats = (props) => {
    const { data } = props;

    return data ? (
        <div className={styles.tags} data-testid='item-noti-tags'>
            <div className={styles.header}>
                <h3 className={styles.title}>Temes relacionats</h3>
            </div>
            <ul className={styles.chipsTemas}>
                {data
                    .sort((a, b) => (b.main ? 1 : 0) - (a.main ? 1 : 0))
                    .map((tag) => (
                        <li key={`tema-relacionat-${tag.id}`}>
                            <Tag tag={tag} tipologia={'DTY_CATEGORY'} />
                        </li>
                    ))}
            </ul>
        </div>
    ) : (
        <></>
    );
};

export default TemesRelacionats;
